import { render } from "./SelecionarTipoDocumentoFinanceiro.vue?vue&type=template&id=5209693e&scoped=true&ts=true"
import script from "./SelecionarTipoDocumentoFinanceiro.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoDocumentoFinanceiro.vue?vue&type=script&lang=ts"

import "./SelecionarTipoDocumentoFinanceiro.vue?vue&type=style&index=0&id=5209693e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5209693e"]])

export default __exports__